export default {
	client_id: '4c4ae40821ba5e1',
	base_url: 'https://api.imgur.com/3',
};
